import { render } from "./LogoutButton.vue?vue&type=template&id=0bbb8084&scoped=true"
import script from "./LogoutButton.vue?vue&type=script&lang=js"
export * from "./LogoutButton.vue?vue&type=script&lang=js"

import "./LogoutButton.vue?vue&type=style&index=0&id=0bbb8084&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0bbb8084"

export default script